(function(module) {
try {
  module = angular.module('betosyswebapp');
} catch (e) {
  module = angular.module('betosyswebapp', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('components/dashboard/vehicleMap/vehicleMapEdit.tpl.html',
    '<label translate="dashBoard.fleetManagement.vehicleList.frameHeight"></label> <input type="text" ng-model="fleetMap.height" class="form-control" font-weight="bolder" maxlength="4">');
}]);
})();



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/vehicleMap/vehicleMapEdit.tpl.js